"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var FooterComponent_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterComponent = void 0;
//ANGULAR2 BITS
const router_1 = require("@angular/router");
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
//INTERNAL LIBRARY BITS
const version_service_1 = require("./version.service");
const bid_data_service_1 = require("./bid-data.service");
const permission_service_1 = require("./permission.service");
const login_service_1 = require("./login.service");
const loading_service_1 = require("./loading.service");
let FooterComponent = FooterComponent_1 = class FooterComponent {
    constructor(_router, _v, _title, _permission, _loginService, _loading, _bidData) {
        this._router = _router;
        this._v = _v;
        this._title = _title;
        this._permission = _permission;
        this._loginService = _loginService;
        this._loading = _loading;
        this._bidData = _bidData;
        this.rollupSubscription = this._bidData.getRollup().subscribe(r => {
            this.rollup = r.rollup;
        });
        this.permissionSubscription = this._permission.getPermissionObservable().subscribe(r => { this.permission = r.permission; });
        this._router.events.subscribe((val) => {
            // see also
            this.currentProduct = this._title.getTitle();
        });
    }
    ccV() {
        this._v.getApplicationVersion();
    }
    showHelpText() {
        if (this.permission && this.permission[`system-branding--biddr_connect`] && (this.currentProduct.indexOf('Dashboard') > -1))
            return FooterComponent_1.BIDDER_CONNECT_HELP_TEXT;
        return false;
    }
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.rollupSubscription.unsubscribe();
    }
};
exports.FooterComponent = FooterComponent;
FooterComponent.BIDDER_CONNECT_HELP_TEXT = `* The numbers shown are not final billable numbers. Please contact your Account Manager for billable numbers 5 days after the close of the month. Thank you.`;
exports.FooterComponent = FooterComponent = FooterComponent_1 = __decorate([
    (0, core_1.Component)({
        selector: 'my-footer',
        templateUrl: 'app/footer.component.html',
        styleUrls: ['styles/app.component.css']
    }),
    __metadata("design:paramtypes", [router_1.Router,
        version_service_1.VersionService,
        platform_browser_1.Title,
        permission_service_1.PermissionService,
        login_service_1.LoginService,
        loading_service_1.LoadingService,
        bid_data_service_1.BidDataService])
], FooterComponent);
//# sourceMappingURL=footer.component.js.map